import {useAxiosClient} from "~/use/axios/client";
import {keepPreviousData} from "@tanstack/vue-query";
import {ContractApi, GmDtoLibraryDtoActionModelsLibraryGetRightToSignListOutput,} from "~/gen/openapi/sblService";
import {MS_HOUR, MS_MINUTE} from "~/constants/time";
import {useOnline} from "@vueuse/core";

export const usePropertyService = () => {
    const { axiosClient } = useAxiosClient()
    const contractApi = new ContractApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()

    const getPropertyRightToSign = (propertyId?: string) => {
        return {
            queryKey: ['getPropertyRightToSign', propertyId],
            queryFn: async () => {
                try {
                    if (propertyId) {
                        return (await contractApi.contractGetPropertyRightToSing(propertyId))?.data as GmDtoLibraryDtoActionModelsLibraryGetRightToSignListOutput // ♫♪♪♫♪
                    }
                } catch (error) {
                    console.error(error)
                    return Promise.reject(error)
                }
            },
            staleTime: 15 * MS_MINUTE,
            refetchOnWindowFocus: false,
            placeholderData: keepPreviousData,
            networkMode: 'offlineFirst',
            gcTime: MS_HOUR,
            enable: isOnline && propertyId
        }
    }

    return {
        getPropertyRightToSign,
    }
}